<div class="ucx-container">
  <!-- Alert Box -->
  <div class="alert-container" *ngIf="isError()">
    <ds-alert
      variant="error"
      closeLabel="{{ closeLabel }}"
      [showCloseButton]="true"
      [disableBorder]="true"
    >
      <div class="alert-content-wrapper">
        <div class="alert-content">
          <ds-icon
            class="mr-8"
            name="error-filled"
            color="error"
            [ariaHidden]="false"
            caption="Error!"
          ></ds-icon>
          <div>
            <p class="alert-heading">
              {{ alertHeading }}
            </p>
            <p class="alert-text">
              {{ alertText }}
            </p>
          </div>
        </div>
      </div>
    </ds-alert>
  </div>
  <!-- Footer Container -->
  <div class="footer-container" [ngClass]="{ 'box-shadow': !isError() }">
    <!-- Input Container -->
    <div class="input-container" [ngClass]="{ disabled: isDisabled }">
      <ucx-address-suggestions
        class="address-height"
        *ngIf="addressList?.length"
        [ngStyle]="{ bottom: suggestionsOffset + 'px' }"
        [addressInput$]="addressList"
        (optionSelected)="selectAddress($event)"
      ></ucx-address-suggestions>
      <div class="input-para">
        <textarea
          #textAreaElement
          name="text"
          id="text"
          placeholder="{{ inputPlaceHolder }}"
          wrap="hard"
          [ngClass]="{
            disabled: isDisabled
          }"
          [disabled]="isDisabled"
          [(ngModel)]="textareaText"
          (input)="adjustTextArea()"
          (keyup)="userTyping()"
          (keydown.enter)="preventNewLine($event)"
          (keyup.enter)="sendInputMessage()"
          (focus)="instantiateOriginalHeight()"
          (change)="userTyping()"
          maxlength="{{ maxNoCharacters + 1 }}"
          rows="1"
        ></textarea>
      </div>

      <!-- Char count & Send button -->
      <div class="right-div" *ngIf="characterCount">
        <div
          class="chat-count"
          *ngIf="isCharCountVisible"
          [ngClass]="{ error: isError() }"
        >
          {{ getRemainingCharCount() }}
        </div>
        <div>
          <button
            class="send-button"
            ucx-icon-button
            [imageSource]="sendMessageIcon"
            [altText]="sendMessageAltText"
            (click)="sendInputMessage()"
            [disabled]="isError()"
          >
            Send
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
